import React from "react";
import "./home.css";
import DomoticNavbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ContactForm from "./Contacto.jsx";
import BrandSlider from "../Components/Secc_marcas.jsx";

// Imágenes servicios
import computoyconferencia from "./img-domotic/computoyvideoconfierencia.png";
import electrosec_cctv from "./img-domotic/electrosec_cctv1.png";
import licenciamiento_soft from "./img-domotic/licenciamiento_de_software.png";
import networking_redes from "./img-domotic/networkingyredes.png";
import pantallas_edu_señ from "./img-domotic/pantallaseducativas_señalizaciondigital.png";
import parqueaderos_inteligentes from "./img-domotic/parqueaderos_inteligentes.png";
import puertas_de_seguridad from "./img-domotic/puertas_seguridad.png";
import sistemas_energia_solar from "./img-domotic/solarsystem1.png";
import sistemas_pos from "./img-domotic/sistemasPOS.png";

// Importar imágenes para los nuevos servicios
import automatizacion from "./img-domotic/automatizacion_service.png";
import plataformas_automatizacion from "./img-domotic/plataformas_a.png";
import negocios_digitales from "./img-domotic/nregociosdigitales.png";
import DomoticChatbot from "../Components/IA/Chatbot-v1.js";

const Home = () => {
  const services = [
    {
      id: 1,
      href: "/Automatizacion",
      title: "AUTOMATIZACIÓN",
      description: "Soluciones de automatización para tu empresa",
      image: automatizacion,
      reverse: false // PRIMERA: Imagen IZQUIERDA, texto DERECHA
    },
    {
      id: 2,
      href: "/SecurityCctv", 
      title: "SEGURIDAD ELECTRÓNICA Y CCTV",
      description: "Sistemas integrales de vigilancia y protección con CCTV de alta definición, alarmas inteligentes y monitoreo remoto 24/7.",
      image: electrosec_cctv,
      reverse: true // SEGUNDA: Imagen DERECHA, texto IZQUIERDA
    },
    {
      id: 3,
      href: "/RedesNetworking",
      title: "REDES Y NETWORKING",
      description: "Infraestructura de red robusta y escalable para entornos empresariales con tecnología de última generación y soporte especializado.",
      image: networking_redes,
      reverse: false // TERCERA: Imagen IZQUIERDA, texto DERECHA
    },
    {
      id: 4,
      href: "/PLAutomatizacion",
      title: "PLATAFORMAS PARA AUTOMATIZACIÓN DE PROCESOS",
      description: "Plataformas de automatización para tu empresa",
      image: plataformas_automatizacion,
      reverse: true // CUARTA: Imagen DERECHA, texto IZQUIERDA
    },
    {
      id: 5,
      href: "/SolarSystems",
      title: "ENERGÍA SOLAR", 
      description: "Soluciones sostenibles y eficientes para reducir costos operativos y contribuir con el medio ambiente mediante tecnología solar avanzada.",
      image: sistemas_energia_solar,
      reverse: false // QUINTA: Imagen IZQUIERDA, texto DERECHA
    },
    {
      id: 6,
      href: "/Puertas-Seguridad",
      title: "PUERTAS DE SEGURIDAD",
      description: "Sistemas de control de acceso de última generación con tecnología biométrica, tarjetas RFID y control remoto para máxima seguridad.",
      image: puertas_de_seguridad,
      reverse: true // SEXTA: Imagen DERECHA, texto IZQUIERDA
    },
    {
      id: 7,
      href: "/IntelligentParking", 
      title: "PARQUEADEROS INTELIGENTES",
      description: "Gestión automatizada de estacionamientos con sensores, cámaras y sistemas de pago integrados para una experiencia sin fricciones.",
      image: parqueaderos_inteligentes,
      reverse: false // SÉPTIMA: Imagen IZQUIERDA, texto DERECHA
    },
    {
      id: 8,
      href: "/ComputoVideoConferencia",
      title: "CÓMPUTO Y VIDEOCONFERENCIA", 
      description: "Equipos y soluciones para comunicación empresarial con tecnología de videoconferencia profesional y equipos de cómputo de alto rendimiento.",
      image: computoyconferencia,
      reverse: true // OCTAVA: Imagen DERECHA, texto IZQUIERDA
    },
    {
      id: 9,
      href: "/Pantallas-Señalización",
      title: "PANTALLAS EDUCATIVAS",
      description: "Soluciones visuales para educación y navegación con pantallas interactivas, sistemas de señalización digital y contenido dinámico.",
      image: pantallas_edu_señ,
      reverse: false // NOVENA: Imagen IZQUIERDA, texto DERECHA
    },
    {
      id: 10,
      href: "/SistemasPOS",
      title: "SISTEMAS POS",
      description: "Soluciones completas para puntos de venta inteligentes que integran hardware y software para optimizar tus operaciones comerciales.",
      image: sistemas_pos,
      reverse: true // DÉCIMA: Imagen DERECHA, texto IZQUIERDA
    },
    {
      id: 11,
      href: "/licenciamiento-software",
      title: "LICENCIAMIENTO DE SOFTWARE",
      description: "Soluciones legales y optimizadas para tu negocio con licencias originales, actualizaciones garantizadas y soporte técnico especializado.",
      image: licenciamiento_soft,
      reverse: false // UNDÉCIMA: Imagen IZQUIERDA, texto DERECHA
    },
    {
      id: 12,
      href: "/NegociosDigitales",
      title: "NEGOCIOS DIGITALES - MODALIDAD RENTING CON OPCIÓN DE COMPRA",
      description: "Computadores, servidores e Impresoras - Sistema de gestión documental.",
      image: negocios_digitales,
      reverse: true // DUODÉCIMA: Imagen DERECHA, texto IZQUIERDA
    }
  ];

  return (
    <div className="domotic-home">
      <DomoticNavbar />
      
      <div className="services-alt-wrapper">
        <section id="alt-servicios" className="alt-section">
          <div className="section-header">
            <h2 className="section-title">NUESTRAS SOLUCIONES TECNOLÓGICAS</h2>
            <div className="section-divider"></div>
          </div>

          <div className="services-container">
            {services.map((service, index) => (
              <div key={service.id} className="service-item-wrapper">
                <a 
                  href={service.href} 
                  className={`service-card ${service.reverse ? 'reverse-layout' : 'normal-layout'}`}
                >
                  <div className="service-image-side">
                    <div className="image-container">
                      <img src={service.image} alt={service.title} className="service-image" />
                      <div className="image-overlay"></div>
                    </div>
                  </div>
                  
                  <div className="service-content-side">
                    <div className="content-wrapper">
                      <h3 className="service-title">{service.title}</h3>
                      <p className="service-description">{service.description}</p>
                      <div className="service-cta">
                        <span className="cta-text">Ver más</span>
                        <span className="cta-arrow">→</span>
                      </div>
                    </div>
                  </div>
                </a>
                
                {index < services.length - 1 && <div className="service-separator"></div>}
              </div>
            ))}
          </div>
        </section>
      </div>

      <BrandSlider />    
      <ContactForm />
      <DomoticChatbot />
      <Footer />
    </div>
  );
};

export default Home;